export default __webpack_public_path__ + "static/media/Logo.7fa17b3b.png";